import { render, staticRenderFns } from "./ThePageFooter.vue?vue&type=template&id=ad2c187e&scoped=true"
import script from "./ThePageFooter.vue?vue&type=script&lang=js"
export * from "./ThePageFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2c187e",
  null
  
)

export default component.exports